import { render } from "./GTComponentSelect.vue?vue&type=template&id=642957cf&scoped=true"
import script from "./GTComponentSelect.vue?vue&type=script&lang=js"
export * from "./GTComponentSelect.vue?vue&type=script&lang=js"

import "./GTComponentSelect.vue?vue&type=style&index=0&id=642957cf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642957cf"]])

export default __exports__